import React, { useContext } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";

import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import EmptyState from "../../components/EmptyState";
import { LanguageContext } from "../../components/LanguageContext";

const ManageUserStoresPage = () => {
    const { translations } = useContext(LanguageContext) || {};
    const { userId } = useParams();

    return (
        <Box>
            <PageHeader
                icon={<StorefrontOutlinedIcon />}
                eyebrow={
                    translations?.adminManageUserStoresPageTitle ||
                    "Korisnik i prodavnice"
                }
                title={`Korisnik #${userId}`}
                description="Dodelite korisniku jednu ili više prodavnica."
            />

            <SectionCard padded={false}>
                <EmptyState
                    icon={<StorefrontOutlinedIcon />}
                    title="Uskoro"
                    description="Funkcionalnost dodele prodavnica korisnicima trenutno nije aktivna."
                />
            </SectionCard>
        </Box>
    );
};

export default ManageUserStoresPage;